import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';

import { ListingModule } from '../listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { VarModule } from '../../directives/ngVar';
import { EditFamilyDialog } from './edit-family-dialog-component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';

import { MatDialogModule } from '@angular/material/dialog';
import { EditPatientDialogModule } from '../edit-patient-dialog/edit-patient-dialog.module';

@NgModule({
  declarations: [
    EditFamilyDialog
  ],
  imports: [
    CommonModule,
    EditPatientDialogModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ListingModule,
    DirectivesModule,
    ReactiveFormsModule,
    VarModule
  ],
  exports: [
    EditFamilyDialog
  ]
})
export class EditFamilyDialogModule {}
